import { api } from '@/services';

export default {
  async fetchRepliquesItems({ commit, dispatch }, payload) {
    const params = new URLSearchParams();

    Object.keys(payload).forEach((key) => {
      const value = payload[key];
      if (Array.isArray(value)) {
        params.append(key, value.join(','));
      } else if (typeof value === 'object' && value !== null) {
        Object.keys(value).forEach((subKey) => {
          params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
        });
      } else if (value) {
        params.append(key, value);
      }
    });

    dispatch('toggleLoading', true, { root: true });

    const { data } = await api.get('/repliques', { params });

    commit('SET_REPLIQUES_TABLE_ITEMS', data.data);
    commit('paginacao/SET_PAGINADOR', data, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async prepararExcel({ getters }) {
    const { getFiltros } = getters;

    const params = new URLSearchParams();

    Object.keys(getFiltros).forEach((key) => {
      const value = getFiltros[key];
      if (Array.isArray(value)) {
        params.append(key, value.join(','));
      } else if (typeof value === 'object' && value !== null) {
        Object.keys(value).forEach((subKey) => {
          params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
        });
      } else if (value) {
        params.append(key, value);
      }
    });

    const { data } = await api.get('/repliques/excel', { params });

    if (!data) return null;

    const excelFormatado = data.map((infoDist) => ({
      eslFilial: infoDist.eslFilial,
      conexosFilial: infoDist.conexosFilial,
      eslCTE: infoDist.eslCTE,
      conexosCTE: infoDist.conexosCTE,
      eslStatus: infoDist.eslStatus,
      conexosStatus: infoDist.conexosStatus,
      chaveAcesso: `'${infoDist.chaveAcesso}'`,
      codigoDocumento: infoDist.codigoDocumento,
      eslSerie: infoDist.eslSerie,
      conexosSerie: infoDist.conexosSerie,
      eslEmissao: infoDist.eslEmissao,
      conexosEmissao: infoDist.conexosEmissao,
      eslPagador: infoDist.eslPagador,
      conexosPagador: infoDist.conexosPagador,
      eslCNPJ: `'${infoDist.eslCNPJ}'`,
      conexosCNPJ: `'${infoDist.conexosCNPJ}'`,
      eslCFOP: infoDist.eslCFOP,
      conexosCFOP: infoDist.conexosCFOP,
      eslBaseICMS: infoDist.eslBaseICMS,
      conexosBaseICMS: infoDist.conexosBaseICMS,
      eslPRCICMS: infoDist.eslPRCICMS,
      conexosPRCICMS: infoDist.conexosPRCICMS,
      eslICMS: infoDist.eslICMS,
      conexosICMS: infoDist.conexosICMS,
      eslTotalNota: infoDist.eslTotalNota,
      conexosTotalNota: infoDist.conexosTotalNota,
    }));

    return excelFormatado;
  },
};
